import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = {
  key: 1,
  class: "ofs pad15 with_white_bg noscroll",
  style: {"height":"90vh"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: /*#__PURE__*/_normalizeClass(`title mt20`)
}, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "fs24 kakugo centered fw600",
    style: {"color":"#696969"}
  }, "管理設定")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "fs13" }, [
  /*#__PURE__*/_createTextVNode(" 同一グループ内のメンバーのみが確認・編集できます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" この公開ページの利用用途など、グループ内で共有するために利用します。 ")
], -1)
const _hoisted_7 = { class: "mt20" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h5", {
  class: "fs18 kakugo text-left fw600",
  style: {"color":"#696969"}
}, "グループタグ", -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = {
  key: 1,
  class: "SuggestsCalendarListContent ofs fl rad8 w98",
  style: {"height":"200px","box-shadow":"0 2px 4px rgba(0, 0, 0, 0.3)","border-top":"1px solid #ebebeb","border-bottom":"1px solid #ebebeb"}
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  class: "centered",
  style: {"margin-top":"50px"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "grey" }, "グループタグが見つかりませんでした。", -1)
const _hoisted_16 = ["src"]
const _hoisted_17 = { key: 2 }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  class: "ml5 fl mt6",
  style: {"width":"calc(100% - 48px)"}
}
const _hoisted_20 = { class: "fs13 mt1 mb1" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_23 = { class: "mt20" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h5", {
  class: "fs18 kakugo text-left fw600",
  style: {"color":"#696969"}
}, "秘密メモ", -1)
const _hoisted_25 = {
  key: 0,
  class: "fr fs12 dgrey"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "mt20" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h5", {
  class: "fs18 kakugo text-left fw600",
  style: {"color":"#696969"}
}, "連絡事項等", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "fs13" }, [
  /*#__PURE__*/_createTextVNode("当日の実施内容など、調整相手に伝えたい内容を入力・編集できます。"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_31 = {
  key: 0,
  class: "fr fs12 dgrey"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_33 = {
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_34 = {
  class: "posAb w50 centered",
  style: {"left":"0","bottom":"0"}
}
const _hoisted_35 = { class: "fs14 fw400" }
const _hoisted_36 = {
  class: "posAb w50 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 whiteColor fw600" }, "保存", -1)
const _hoisted_38 = [
  _hoisted_37
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_ChipButton = _resolveComponent("ChipButton")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_ListLoader = _resolveComponent("ListLoader")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VueFinalModal, {
      "modal-id": "PrivateMemoModal",
      "content-class": "rad10 with_white_bg shadowContent modalStandard noscroll",
      onBeforeOpen: _ctx.openModal
    }, {
      default: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.room)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              (_ctx.memoType == `private_memo`)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _hoisted_5,
                    _hoisted_6,
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      (_ctx.selectedTags)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedTags, (grTag, grtagindex) => {
                              return (_openBlock(), _createBlock(_component_ChipButton, {
                                key: `${grtagindex}${grTag.systemUpdatedAt}${grTag.name}${_ctx.selectedTags.length}`,
                                name: `${grTag.name}`,
                                returnVal: grTag,
                                onSelect: ($event: any) => (_ctx.clickSelectGrtag(grTag)),
                                onDelete: ($event: any) => (_ctx.deleteSelectGrtag(grTag)),
                                style: ``,
                                color: grTag.color,
                                class: "mr5 mb4"
                              }, null, 8, ["name", "returnVal", "onSelect", "onDelete", "color"]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_MdTextfieldTag, {
                        placeholder: "グループタグ名を入力",
                        style: `min-width: 270px;padding-top:0;min-height:inherit;margin:0`,
                        class: "fl fs12 roundForm w100 searchField rad7",
                        value: _ctx.searchText,
                        onInputValue: _ctx.inputSearchText,
                        onClickTextfield: _ctx.clickSearchField,
                        onBlur: _ctx.blurSearchField,
                        onEnter: _ctx.enterSearch
                      }, null, 8, ["value", "onInputValue", "onClickTextfield", "onBlur", "onEnter"]),
                      _hoisted_10,
                      (_ctx.showSuggests)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            (!_ctx.searchedTags)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _createVNode(_component_ListLoader)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.searchedTags.length == 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  _createElementVNode("div", _hoisted_14, [
                                    _hoisted_15,
                                    _createElementVNode("img", {
                                      src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                                      width: "30",
                                      height: "30"
                                    }, null, 8, _hoisted_16)
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("ul", _hoisted_17, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchedTags, (grtag, grindex) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: `${grindex}${grtag.name}`,
                                      style: {"height":"46px"},
                                      class: _normalizeClass(`pointer w100 ofh posRe pad10`),
                                      onClick: ($event: any) => (_ctx.selectGroupTag(grtag))
                                    }, [
                                      _createElementVNode("div", {
                                        class: "fl rad6 mt9 mr2",
                                        style: _normalizeStyle({
                                            width: `12px`,
                                            height: `12px`,
                                            backgroundColor: `#${grtag.color}`,
                                        })
                                      }, "   ", 4),
                                      _createElementVNode("div", _hoisted_19, [
                                        _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_20, [
                                          _createTextVNode(_toDisplayString(_ctx.truncate(grtag.name || ``, 20)), 1)
                                        ])), [
                                          [_directive_tooltip, grtag.name && grtag.name.length > 20 ? grtag.name : null]
                                        ])
                                      ]),
                                      _hoisted_21
                                    ], 8, _hoisted_18))
                                  }), 128))
                                ]))
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_22
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _createVNode(_component_TextareaTag, {
                        placeholder: "○○に設置して利用しています。変更しないようお願いします。",
                        style: {"height":"200px"},
                        class: "fs14 roundForm mw100 privateMemoArea",
                        value: _ctx.memo,
                        maxlength: 100,
                        onClickTextarea: _ctx.clickTextarea,
                        onInputValue: _ctx.inputTextarea
                      }, null, 8, ["value", "onClickTextarea", "onInputValue"]),
                      (_ctx.memo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.memo.length) + "/100", 1))
                        : _createCommentVNode("", true),
                      _hoisted_26
                    ])
                  ]))
                : (_ctx.memoType == `open_schedule_memo`)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _hoisted_30,
                        _createVNode(_component_TextareaTag, {
                          placeholder: "当日は◯◯にお越しください。",
                          style: {"height":"200px"},
                          class: "fs14 roundForm mw100 privateMemoArea",
                          value: _ctx.memo,
                          maxlength: 10000,
                          onClickTextarea: _ctx.clickTextarea,
                          onInputValue: _ctx.inputTextarea
                        }, null, 8, ["value", "onClickTextarea", "onInputValue"]),
                        (_ctx.memo)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.memo.length) + "/10000", 1))
                          : _createCommentVNode("", true),
                        _hoisted_32
                      ])
                    ]))
                  : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("section", {
              class: "with_white_bg dgrey fs16 pointer centered",
              style: {"line-height":"50px","height":"50px"},
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancelInput && _ctx.cancelInput(...args)))
            }, [
              _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t(`title.close`)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("section", {
              class: "w100 skyblueBg fs16 pointer centered",
              style: {"line-height":"50px","height":"50px"},
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)))
            }, _hoisted_38)
          ])
        ])
      ]),
      _: 1
    }, 8, ["onBeforeOpen"])
  ]))
}